export function MoveInArray<T>(arr: T[] , from: number, to: number) {

	// Delete the item from it's current position
	var item = arr.splice(from, 1);

	// Move the item to its new position
	arr.splice(to, 0, item[0]);
};